/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it ignore case and whitespace?`)
};

const es_rd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Ignora mayúsculas y espacios en blanco?`)
};

const de_rd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werden Groß-/Kleinschreibung und Leerzeichen ignoriert?`)
};

const nl_rd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negeert het hoofdletters en witruimte?`)
};

const fr_rd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignore-t-il la casse et les espaces ?`)
};

const it_rd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignora maiuscole/minuscole e spazi bianchi?`)
};

const pt_br2_rd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignora maiúsculas e espaços em branco?`)
};

const pt_rd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignora maiúsculas e espaços em branco?`)
};

const ja_rd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大文字小文字と空白を無視しますか?`)
};

const zh_rd_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是否会忽略大小写和空格？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rd_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rd_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rd_faq2_q", locale)
	if (locale === "en") return en_rd_faq2_q(inputs)
	if (locale === "es") return es_rd_faq2_q(inputs)
	if (locale === "de") return de_rd_faq2_q(inputs)
	if (locale === "nl") return nl_rd_faq2_q(inputs)
	if (locale === "fr") return fr_rd_faq2_q(inputs)
	if (locale === "it") return it_rd_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_rd_faq2_q(inputs)
	if (locale === "pt") return pt_rd_faq2_q(inputs)
	if (locale === "ja") return ja_rd_faq2_q(inputs)
	return zh_rd_faq2_q(inputs)
};